import React, { useEffect } from 'react';
import {
  Select,
  MenuItem,
  Typography,
  Box,
  FormControl,
  Tooltip,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { styled } from '@mui/system';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { resolveFieldsService } from '../../apis/EntitiesSelection';
import { fetchSqlTableFields, getConnectionById } from '../../apis/Connections';

function JoinFunc({
  workflowId,
  updatedConfig,
  sourceField,
  setSourceField,
  sourceEntity,
  setSourceEntity,
  referenceEntity,
  setReferenceEntity,
  referenceField,
  setReferenceField,
  matchonField,
  setMatchonField,
  functionTypejoin,
  setFunctionTypejoin,
  selectedFields,
  selectedEntities,
  referenceFields,
  setReferenceFields,
  //eslint-disable-next-line
  selectedFieldName,
  //eslint-disable-next-line
  setSelectedFieldName,
  referenceConnection,
  setReferenceConnection,
  selectedConnections,
}) {
  // const sourceNode = updatedConfig?.nodes?.find(
  //   (node) => node?.config?.type === 'sourceNode',
  // );

  // Get all sourceNodes - check both node.type and node.config.type for compatibility
  const sourceNodes = updatedConfig?.nodes?.filter(
    (node) =>
      node?.type === 'sourceNode' ||
      node?.type === 'source' ||
      node?.config?.type === 'sourceNode' ||
      node?.config?.type === 'source',
  );

  // Build connection details for dropdowns if needed
  const connectionDetails = sourceNodes.map((sourceNode) => ({
    connName: sourceNode?.config?.connection?.conn_name || '',
    connId: sourceNode?.config?.connection?.conn_id || '',
  }));

  console.log('conn updatedConfig', updatedConfig);
  console.log('conn sourceNodes', sourceNodes);
  console.log('conn updatedConfig', updatedConfig);
  console.log('conn connectionDetails', connectionDetails);
  console.log('conn selectedFields', selectedFields);
  console.log('conn selectedEntities', selectedEntities);
  console.log('conn selectedConnections', selectedConnections);

  useEffect(() => {
    if (Array.isArray(connectionDetails)) {
      if (connectionDetails.length === 1) {
        setReferenceConnection(connectionDetails[0].connId);
      } else if (connectionDetails.length === 0) {
        setReferenceConnection('');
      }
      // when >1 we keep whatever the user picked
    }
  }, [connectionDetails, setReferenceConnection]);

  useEffect(() => {
    if (selectedFields?.length > 0 && !sourceField) {
      setSourceField(selectedFields[0]);
    }
    if (selectedEntities?.length > 0 && !sourceEntity) {
      setSourceEntity(selectedEntities[0]);
    }
  }, [selectedFields, selectedEntities, sourceField, sourceEntity]);

  // const sourceKey = `${sourceNode.id}-${sourceNode?.config?.connection?.conn_id || ''}-${
  //   sourceNode?.config?.module || ''
  // }`;
  // Build unique sourceKeys
  const sourceKeys = Array.from(
    new Set(
      sourceNodes.map(
        (node) =>
          `${node.id}-${node?.config?.connection?.conn_id || ''}-${node?.config?.module || ''}`,
      ),
    ),
  );
  const entitiesByWorkflow = useSelector(
    (state) => state.entities.entitiesByWorkflow,
  );
  const finalConfigPayload = useSelector(
    (state) => state.mapping.finalConfigPayloadByWorkflow?.[workflowId],
  );
  console.log('conn finalConfigPayload:', finalConfigPayload);
  // const entityList = entitiesByWorkflow?.[workflowId]?.[sourceKey] || [];
  // Build entityList
  let entityList = [];
  if (sourceKeys.length === 1) {
    // Single sourceNode
    entityList = entitiesByWorkflow?.[workflowId]?.[sourceKeys[0]] || [];
  } else {
    // Multiple sourceNodes
    entityList = sourceKeys.flatMap(
      (key) => entitiesByWorkflow?.[workflowId]?.[key] || [],
    );

    // Optional: remove duplicates if entities are identical across multiple keys
    const seen = new Set();
    entityList = entityList.filter((entity) => {
      const id = entity.id || entity.name || JSON.stringify(entity);
      if (seen.has(id)) return false;
      seen.add(id);
      return true;
    });
  }

  console.log('conn entityList:', entityList);

  const resolvedData = useSelector(
    (state) => state.mapping.resolvedFieldsByWorkflow?.[workflowId],
  );
  console.log('resolvedData:', resolvedData);

  const referenceEntityOptions = entityList
    .filter(
      (e) =>
        e.entity_name.trim().toLowerCase() !==
        (sourceEntity || '').trim().toLowerCase(),
    )
    .map((e) => ({
      value: e.entity_name, // what backend needs
      label: e.label || e.entity_name, // what UI shows
    }));

  const renderBy = (options) => (val) => {
    if (!val) return '';
    const hit = options.find((o) => o.value === val);
    return hit ? hit.label : String(val);
  };
  const MENU_PROPS = {
    anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
    transformOrigin: { vertical: 'top', horizontal: 'left' },
    marginThreshold: 0,
    PaperProps: {
      sx: {
        maxHeight: 240,
        mt: 0.5,
        minWidth: 0,
        width: '200px',
      },
    },

    MenuListProps: {
      dense: true,
      sx: { py: 0 },
    },
  };

  const StyledSelect = styled(Select)({
    width: '100%',
    fontSize: '0.938rem',
    borderRadius: '4px',
    '& .MuiOutlinedInput-root': {
      height: '40px',
      borderRadius: '4px',
      paddingRight: '32px',
    },
    '& .MuiSelect-select': {
      padding: '7px 12px',
      display: 'flex',
      alignItems: 'center',
      fontSize: '0.938rem',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(0, 0, 0, 0.5)',
    },
  });

  useEffect(() => {
    if (!selectedEntities?.length || !resolvedData?.length) {
      setSelectedFieldName([]);
      return;
    }

    // Lowercase the entity names to handle case insensitivity
    const entityNamesLower = selectedEntities
      .map(
        (ent) =>
          typeof ent === 'string'
            ? ent.toLowerCase()
            : ent?.entity_name?.toLowerCase(), // Use optional chaining to prevent undefined errors
      )
      .filter(Boolean); // This will filter out undefined or null values

    // Filter and map fields based on resolved data and entity names
    const allFields = resolvedData
      .filter(
        (node) =>
          (node.type === 'source' || node.type === 'sourceNode') &&
          entityNamesLower.includes(node?.fields?.entity_name?.toLowerCase()),
      )
      .flatMap((node) => node?.fields?.fields || [])
      .map((field) => ({
        fieldName: field.field_name || field.field_label,
        fieldLabel: field.field_label,
      }))
      .filter((field) => typeof field.fieldLabel === 'string');

    // Create a set of selected fields (case insensitive)
    const selectedFieldSet = new Set(
      (selectedFields || []).map((f) => f?.toLowerCase()).filter(Boolean),
    );

    // Create an array of field names corresponding to selected field labels
    const selectedFieldNames = allFields
      .filter((field) => selectedFieldSet.has(field.fieldLabel?.toLowerCase()))
      .map((field) => field.fieldName);

    console.log('conn selectedFieldNames:', selectedFieldNames);

    setSelectedFieldName(selectedFieldNames);
  }, [selectedEntities, resolvedData, selectedFields]);

  const handleReferenceFieldChange = (e) => {
    setReferenceField(e.target.value);
  };

  // Helper function to check if config is SQL
  const isSqlConfig = (config) => {
    const connector =
      config?.connection?.connector_name ||
      config?.connection?.connector ||
      config?.label ||
      '';
    return (
      typeof connector === 'string' && connector.toLowerCase().includes('sql')
    );
  };

  // Helper function to get SQL metadata
  const getSqlMetadata = async (config) => {
    if (!config?.connection?.conn_id) return null;
    try {
      const connection = await getConnectionById(config.connection.conn_id);
      const params = connection?.custom_params || {};
      const token =
        params.token || params.quick_test_token || connection?.token || null;
      return token ? { token } : null;
    } catch (err) {
      console.error('Failed to get SQL metadata:', err);
      return null;
    }
  };

  // Helper function to normalize SQL fields response
  const normalizeSqlFields = (response) => {
    if (!response) return [];
    const candidates =
      response.fields?.fields ||
      response.fields ||
      response.columns ||
      response.schema ||
      response.data ||
      response.result ||
      response;
    const fields = Array.isArray(candidates) ? candidates : [];
    return fields
      .map((field) => {
        if (!field || typeof field !== 'object') return null;
        const fieldName =
          field.field_name ||
          field.column_name ||
          field.name ||
          field.columnName ||
          '';
        if (!fieldName) return null;
        const label =
          field.field_label ||
          field.display_name ||
          field.column_label ||
          field.column_name ||
          field.name ||
          fieldName;
        return {
          field_name: fieldName,
          field_label: label,
        };
      })
      .filter(Boolean);
  };

  const handleReferenceEntityChange = async (e = null) => {
    // const selected = e.target.value;
    const selected = e ? e.target.value : referenceEntity; // Use the event value or the current referenceEntity value
    setReferenceEntity(selected);
    setReferenceField('');

    const enrichedPayload = Object.values(finalConfigPayload)
      .filter((n) => n.type === 'source' || n.type === 'sourceNode')
      .map((n) => ({
        ...n,
        selectedEntities: [{ entity_name: selected, label: selected }],
      }));

    if (selected && enrichedPayload.length) {
      try {
        // Separate SQL and non-SQL configs
        const sqlConfigs = enrichedPayload.filter(isSqlConfig);
        const nonSqlConfigs = enrichedPayload.filter(
          (cfg) => !isSqlConfig(cfg),
        );

        let fieldOptionsRaw = [];

        // Handle non-SQL configs (e.g., Salesforce)
        if (nonSqlConfigs.length > 0) {
          const response = await resolveFieldsService({
            label: 'FieldResolution',
            configs: nonSqlConfigs,
          });
          fieldOptionsRaw = Array.isArray(response)
            ? response[0]?.fields?.fields || []
            : [];
        }

        // Handle SQL configs
        if (sqlConfigs.length > 0) {
          const sqlConfig = sqlConfigs[0]; // Use first SQL config
          const metadata = await getSqlMetadata(sqlConfig);
          if (metadata?.token) {
            const sqlResponse = await fetchSqlTableFields(
              metadata.token,
              selected,
            );
            const sqlFields = normalizeSqlFields(sqlResponse);
            fieldOptionsRaw = [...fieldOptionsRaw, ...sqlFields];
          }
        }

        // Convert to { value, label } using field_name/field_label:
        const fieldOptions = fieldOptionsRaw
          .map((f) => ({
            value: f.field_name, // backend value
            label: f.field_label || f.field_name, // UI label
          }))
          .filter((f) => typeof f.value === 'string');

        setReferenceFields(fieldOptions);
        if (!referenceField && fieldOptions.length) {
          setReferenceField(fieldOptions[0].value); // Set referenceField to the first available value
        } else if (
          referenceField &&
          fieldOptions.some((option) => option.value === referenceField)
        ) {
          // If referenceField already has a value that exists in fieldOptions, retain it
          // Otherwise, set it to the first field option
          setReferenceField(referenceField);
        } // Set the first field as the default
      } catch (err) {
        console.error('Failed to fetch reference fields:', err);
        setReferenceFields([]);
      }
    } else {
      setReferenceFields([]);
    }
  };

  useEffect(() => {
    if (referenceEntity) {
      handleReferenceEntityChange(); // Call the function even when referenceEntity has a value
    }
  }, [referenceEntity]);
  // Correctly handle the reference field value

  console.log('referenceField:', referenceField);
  console.log('referenceFields:', referenceFields);

  return (
    <>
      {' '}
      <Box mt={1}>
        <FormControl fullWidth margin="normal">
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Source Entity
          </Typography>
          <StyledSelect
            value={sourceEntity || ''}
            MenuProps={MENU_PROPS}
            onChange={(e) => setSourceEntity(e.target.value)}
          >
            {selectedEntities.map((entity, index) => (
              <MenuItem
                key={index}
                value={entity}
                sx={{ minHeight: 'auto', py: 0.5, fontSize: 14 }}
              >
                {entity}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>

        <FormControl fullWidth margin="normal">
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Source Field
          </Typography>
          <StyledSelect
            value={sourceField || ''}
            MenuProps={MENU_PROPS}
            onChange={(e) => setSourceField(e.target.value)}
          >
            {selectedFields.map((field, index) => (
              <MenuItem
                key={index}
                value={field}
                sx={{ minHeight: 'auto', py: 0.5, fontSize: 14 }}
              >
                {field}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>

        {connectionDetails.length > 1 && (
          <FormControl fullWidth margin="normal">
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              Reference Connection
            </Typography>
            <StyledSelect
              value={referenceConnection || ''}
              MenuProps={MENU_PROPS}
              onChange={(e) => setReferenceConnection(e.target.value)}
            >
              {connectionDetails.map((connection, index) => (
                <MenuItem
                  key={index}
                  value={connection.connId}
                  sx={{ minHeight: 'auto', py: 0.5, fontSize: 14 }}
                >
                  {connection.connName}
                </MenuItem>
              ))}
            </StyledSelect>
          </FormControl>
        )}

        <FormControl fullWidth margin="normal">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              Reference Entity
            </Typography>
            <Tooltip title="Reference entity from source node" arrow>
              <InfoOutlinedIcon
                sx={{ fontSize: 16, color: 'text.secondary', cursor: 'help' }}
              />
            </Tooltip>
          </Box>
          {/* Reference Entity (value = entity_name, label shown) */}
          <StyledSelect
            value={referenceEntity || ''} // stores entity_name
            MenuProps={MENU_PROPS}
            onChange={handleReferenceEntityChange}
            renderValue={renderBy(referenceEntityOptions)}
          >
            <MenuItem value="" disabled>
              Select
            </MenuItem>
            {referenceEntityOptions.map((opt) => (
              <MenuItem
                key={opt.value}
                value={opt.value}
                sx={{ minHeight: 'auto', py: 0.5, fontSize: 14 }}
              >
                {opt.label}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>

        <FormControl fullWidth margin="normal">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              Reference Field
            </Typography>
            <Tooltip
              title="Fields from the selected source Reference entity"
              arrow
            >
              <InfoOutlinedIcon
                sx={{ fontSize: 16, color: 'text.secondary', cursor: 'help' }}
              />
            </Tooltip>
          </Box>
          {/* Reference Field (value = field_name, label shown) */}
          <StyledSelect
            value={referenceField || ''} // stores field_name
            MenuProps={MENU_PROPS}
            // onChange={(e) => setReferenceField(e.target.value)}
            onChange={handleReferenceFieldChange}
            renderValue={renderBy(referenceFields)}
          >
            <MenuItem value="">Select</MenuItem>
            {referenceFields.map((opt) => (
              <MenuItem
                key={opt.value}
                value={opt.value}
                sx={{ minHeight: 'auto', py: 0.5, fontSize: 14 }}
              >
                {opt.label}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>

        <FormControl fullWidth margin="normal">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              Match On
            </Typography>
            <Tooltip title="The field on the basis it will match" arrow>
              <InfoOutlinedIcon
                sx={{ fontSize: 16, color: 'text.secondary', cursor: 'help' }}
              />
            </Tooltip>
          </Box>
          {/* Match On (reuse same field options) */}
          <StyledSelect
            value={matchonField || ''}
            MenuProps={MENU_PROPS}
            onChange={(e) => setMatchonField(e.target.value)}
            renderValue={renderBy(referenceFields)}
          >
            <MenuItem value="">Select</MenuItem>
            {referenceFields.map((opt) => (
              <MenuItem
                key={opt.value}
                value={opt.value}
                sx={{ minHeight: 'auto', py: 0.5, fontSize: 14 }}
              >
                {opt.label}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>

        <FormControl fullWidth margin="normal">
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Function
          </Typography>
          <StyledSelect
            value={functionTypejoin || ''}
            MenuProps={MENU_PROPS}
            onChange={(e) => setFunctionTypejoin(e.target.value)}
          >
            <MenuItem value="" disabled>
              Select
            </MenuItem>

            <MenuItem value="none">None</MenuItem>

            <MenuItem value="Multiply">Multiply</MenuItem>
            <MenuItem value="Divide">Divide</MenuItem>
            <MenuItem value="Add">Add</MenuItem>
            <MenuItem value="Subtract">Subtract</MenuItem>
          </StyledSelect>
        </FormControl>
      </Box>
    </>
  );
}

JoinFunc.propTypes = {
  selectedEntities: PropTypes.array.isRequired,
  selectedFields: PropTypes.array.isRequired,
  referenceEntityList: PropTypes.array.isRequired,
  referenceEntity: PropTypes.string.isRequired,
  setReferenceEntity: PropTypes.func.isRequired,
  sourceEntity: PropTypes.string.isRequired,
  setSourceEntity: PropTypes.func.isRequired,
  sourceField: PropTypes.string.isRequired,
  setSourceField: PropTypes.func.isRequired,
  referenceField: PropTypes.string.isRequired,
  setReferenceField: PropTypes.func.isRequired,
  matchonField: PropTypes.string.isRequired,
  setMatchonField: PropTypes.func.isRequired,
  functionTypejoin: PropTypes.string.isRequired,
  setFunctionTypejoin: PropTypes.func.isRequired,
  selectedFieldName: PropTypes.array,
  setSelectedFieldName: PropTypes.func,
  referenceFields: PropTypes.array.isRequired,
  setReferenceFields: PropTypes.func.isRequired,
  updatedConfig: PropTypes.object.isRequired,
  workflowId: PropTypes.string.isRequired,
  referenceConnection: PropTypes.string.isRequired,
  setReferenceConnection: PropTypes.func.isRequired,
  selectedConnections: PropTypes.array.isRequired,
};

export default JoinFunc;
